import "./MainFooter.scss";
import { Link } from "react-router-dom";
import IGLogo from "../assets/global/ig-logo.png";
import FBLogo from "../assets/global/fb-logo.png";
import { FooterLogo } from "../assets/global/Icons";
import { IG_URL, FB_URL, CURR_YEAR, SERVICES_ENABLED } from "../common/constants";

function MainFooter() {
  return (
    <footer className="main-footer">
      <div className="main-footer__container">
        <Link to="/">
          <FooterLogo className="main-footer__logo" />
        </Link>
        <div className="main-footer__quick-links">
          <h5>Quick Links</h5>
          <nav className="footer-nav">
            <ul className="footer-nav__list">
              <div className="footer-nav__col">
                <li>
                  <Link to="/" className="footer-nav__link">
                    Home
                  </Link>
                </li>

                <li>
                  <Link to="/menu" className="footer-nav__link">
                    Menu
                  </Link>
                </li>
                {SERVICES_ENABLED && (
                  <li>
                    <Link to="/services" className="footer-nav__link">
                      Services
                    </Link>
                  </li>
                )}
              </div>
              <div className="footer-nav__col">
                <li>
                  <Link to="/classes" className="footer-nav__link">
                    Classes
                  </Link>
                </li>
                <li>
                  <Link to="/gallery" className="footer-nav__link">
                    Gallery
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="footer-nav__link">
                    About
                  </Link>
                </li>
              </div>
              <div className="footer-nav__col">
                <li>
                  <Link to="/order" className="footer-nav__link">
                    Order
                  </Link>
                </li>
                <li>
                  <Link to="/faqs" className="footer-nav__link">
                    FAQs
                  </Link>
                </li>
              </div>
            </ul>
          </nav>
        </div>
        <div className="main-footer__contact">
          <h5>Contact</h5>
          <p>Mountain View, CA</p>
          <p>408-800-2092</p>
          <p>
            <a href="mailto:connie@conniescakerie.com">
              connie@conniescakerie.com
            </a>
          </p>
        </div>
        <div className="main-footer__socials">
          <div className="socials__section">
            <a href={IG_URL} target="_blank" rel="noopener noreferrer">
              <img src={IGLogo} className="socials__logo" />
            </a>
            <div className="socials__text">
              <h5>
                <a
                  href={IG_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="socials__link"
                >
                  Instagram
                </a>
              </h5>
              <p>Follow us and view our latest posts</p>
            </div>
          </div>
          <div className="socials__section">
            <a href={FB_URL} target="_blank" rel="noopener noreferrer">
              <img src={FBLogo} className="socials__logo" />
            </a>
            <div className="socials__text">
              <h5>
                <a
                  href={FB_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="socials__link"
                >
                  Facebook
                </a>
              </h5>
              <p>Like our page and write a review</p>
            </div>
          </div>
        </div>
      </div>
      <p className="main-footer__copyright">
        &copy; {CURR_YEAR} Connie's Cakerie. All rights reserved.
      </p>
    </footer>
  );
}

export default MainFooter;
